import React from "react";
import Link from "next/link";
import { SidebarMenuButton, SidebarMenuItem } from "@src/lib/ui/Sidebar";
import { useRouter } from "next/router";
import PinsOutlineIcon from "@src/lib/icons/18px/pins-outline";

const AdminLeftNavLocationsMenuButton: React.FC = () => {
  const { pathname } = useRouter();
  const isActive = pathname.startsWith("/locations");
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip="Locations" isActive={isActive}>
        <Link href="/locations">
          <PinsOutlineIcon />
          Locations
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

export default AdminLeftNavLocationsMenuButton;
